/**
 * CoHostZone Color Constants — single source of truth for JS/TS contexts.
 * CSS files use the variables defined in style.scss :root — keep in sync.
 *
 * To change the brand: update both this file AND :root in style.scss.
 */

/* ── Brand Gold ──────────────────────────────────────────────────────── */
const gold        = '#EFD63B';   // --col-gold
const goldHover   = '#D9C235';   // --col-gold-hover
const goldDark    = '#B38811';   // --col-gold-dark
const goldDarker  = '#9A7410';   // --col-gold-darker
const goldPale    = '#E8D88A';   // --col-gold-pale

/* ── Dark Neutrals ───────────────────────────────────────────────────── */
const espresso      = '#17100A'; // --col-espresso
const nearBlack     = '#140F0A'; // --col-near-black
const darkBg        = '#120D08'; // --col-dark-bg
const darkSurface   = '#1D1410'; // --col-dark-surface
const darkElevated  = '#231810'; // --col-dark-elevated
const darkGoldLight = '#2A1F0E'; // MUI dark primary.light

/* ── Light Neutrals ──────────────────────────────────────────────────── */
const cream    = '#FEFDF4';   // --col-cream
const offWhite = '#FFFDF8';   // --col-off-white
const ivory    = '#F7F1DE';   // --col-ivory

/* ── Text ────────────────────────────────────────────────────────────── */
const warmBrown  = '#7B6A55'; // --col-warm-brown
const lightBrown = '#9B8B77'; // --col-light-brown
const creamText  = '#F5EFE6'; // --col-cream-text

/* ── Status ──────────────────────────────────────────────────────────── */
const success     = '#5DB87A'; // --col-success
const successBg   = '#BFE3C5'; // --col-success-bg
const successDark = '#3D7A4A'; // --col-success-dark
const warning     = '#D8B04A'; // --col-warning
const warningBg   = '#FBF0D5'; // --col-warning-bg
const warningDark = '#8B6200'; // --col-warning-dark
const danger      = '#E05A4B'; // --col-danger
const dangerBg    = '#FFE5E5'; // --col-danger-bg
const dangerDark  = '#C0392B'; // --col-danger-dark

export const APP_COLORS = {
  gold, goldHover, goldDark, goldDarker, goldPale,
  espresso, nearBlack, darkBg, darkSurface, darkElevated, darkGoldLight,
  cream, offWhite, ivory,
  warmBrown, lightBrown, creamText,
  success, successBg, successDark,
  warning, warningBg, warningDark,
  danger, dangerBg, dangerDark,
} as const;
